"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchSafeliteDetails = exports.fetchPolicyVehicleList = exports.fetchPolicyDocuments = exports.fetchPolicyBilling = exports.fetchPolicy = exports.fetchCoverageForms = exports.clearAssociatePolicy = exports.associatePolicyPostSecurityQuestions = exports.associatePolicyGetSecurityQuestions = exports.associatePolicy = void 0;
var _types = _interopRequireDefault(require("./types"));
var _environment = _interopRequireDefault(require("../../environment"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/* ACTION CREATOR FUNCTIONS
Put here the functions that return an action object that can be dispatched
HINT: Always use functions for consistency, don't export plain objects
*/

var getPolicyUrl = _environment.default.POLICY.policyUrl;
var getPolicyBillingUrl = _environment.default.POLICY.policyBilling;
var getPolicyDocumentsUrl = _environment.default.POLICY.policyDocuments;
var getCoverageFormsUrl = _environment.default.POLICY.coverageForms;
var associatePolicyUrl = _environment.default.POLICY.associatePolicy;
var associatePolicyGetSecurityQuestionsUrl = _environment.default.POLICY.associatePolicyGetSecurityQuestions;
var associatePolicyPostSecurityQuestionsUrl = _environment.default.POLICY.associatePolicyPostSecurityQuestions;
var getPolicyVehicleListURL = _environment.default.POLICY.policyVehicleList;
var fetchPolicy = exports.fetchPolicy = function fetchPolicy(policyNumber, apiVersion) {
  return {
    type: _types.default.FETCH_POLICY_REQUEST,
    meta: {
      async: true,
      blocking: true,
      method: 'GET',
      url: _url(getPolicyUrl, policyNumber),
      apiVersion: apiVersion
    }
  };
};
var fetchPolicyBilling = exports.fetchPolicyBilling = function fetchPolicyBilling(policyNumber, apiVersion) {
  return {
    type: _types.default.FETCH_POLICY_BILLING_REQUEST,
    meta: {
      async: true,
      blocking: true,
      method: 'GET',
      url: _url(getPolicyUrl, policyNumber, getPolicyBillingUrl),
      apiVersion: apiVersion
    }
  };
};
var fetchPolicyDocuments = exports.fetchPolicyDocuments = function fetchPolicyDocuments(policyNumber, policy, apiVersion) {
  return {
    type: _types.default.FETCH_POLICY_DOCUMENTS_REQUEST,
    meta: {
      async: true,
      blocking: true,
      method: 'POST',
      url: _url(getPolicyUrl, policyNumber, getPolicyDocumentsUrl),
      body: policy,
      apiVersion: apiVersion
    }
  };
};
var fetchCoverageForms = exports.fetchCoverageForms = function fetchCoverageForms(policyNumber) {
  return {
    type: _types.default.FETCH_COVERAGE_FORMS_REQUEST,
    meta: {
      async: true,
      blocking: true,
      method: 'GET',
      url: _url(getPolicyUrl, policyNumber, getCoverageFormsUrl)
    }
  };
};
var associatePolicy = exports.associatePolicy = function associatePolicy(pinNumber, policyNumber, email) {
  return {
    type: _types.default.ASSOCIATE_POLICY_REQUEST,
    meta: {
      async: true,
      blocking: true,
      method: 'POST',
      url: _url(associatePolicyUrl),
      body: {
        pinNumber: pinNumber.trim(),
        policyNumber: policyNumber.trim()
      }
    }
  };
};
var associatePolicyGetSecurityQuestions = exports.associatePolicyGetSecurityQuestions = function associatePolicyGetSecurityQuestions(policyNumber) {
  return {
    type: _types.default.ASSOCIATE_POLICY_GET_SECURITY_QUESTIONS_REQUEST,
    meta: {
      async: true,
      blocking: true,
      method: 'GET',
      url: _url(associatePolicyGetSecurityQuestionsUrl, policyNumber)
    }
  };
};
var associatePolicyPostSecurityQuestions = exports.associatePolicyPostSecurityQuestions = function associatePolicyPostSecurityQuestions(policyNumber, answer) {
  return {
    type: _types.default.ASSOCIATE_POLICY_POST_SECURITY_QUESTIONS_REQUEST,
    meta: {
      async: true,
      blocking: true,
      method: 'POST',
      url: associatePolicyPostSecurityQuestionsUrl,
      body: {
        policyNumber: policyNumber,
        answer: answer
      }
    }
  };
};
var clearAssociatePolicy = exports.clearAssociatePolicy = function clearAssociatePolicy() {
  return {
    type: _types.default.ASSOCIATE_POLICY_CLEAR
  };
};
var fetchPolicyVehicleList = exports.fetchPolicyVehicleList = function fetchPolicyVehicleList(policyNumbers) {
  return {
    type: _types.default.FETCH_POLICY_VEHICLE_LIST_REQUEST,
    meta: {
      async: true,
      blocking: true,
      method: 'POST',
      url: _url(getPolicyUrl, getPolicyVehicleListURL),
      body: policyNumbers
    }
  };
};
var fetchSafeliteDetails = exports.fetchSafeliteDetails = function fetchSafeliteDetails(vin, policyNumber) {
  return {
    type: _types.default.FETCH_SAFELITE_DETAILS_REQUEST,
    meta: {
      async: true,
      blocking: false,
      method: 'POST',
      url: _url(getPolicyUrl, policyNumber, 'vin', vin, 'safelite-token')
    }
  };
};

// Private

var _url = function _url() {
  for (var _len = arguments.length, fragments = new Array(_len), _key = 0; _key < _len; _key++) {
    fragments[_key] = arguments[_key];
  }
  var url = fragments.join('/');
  return url;
};